import { Component, Input } from '@angular/core';
import { PlatformTourService } from '../../../../platform-tour/platform-tour-service/platform-tour.service';
import { OeAppPersonService } from '../../../../shared/oe-app-person.service';
import { DEFAULT_CAROUSEL_SETTINGS } from '../../../../shared/types/CarouselSettings';
import { LiveClassDto } from '../../../../shared/types/LiveClassDto';
import { ImageCardConfig } from '../../image-card-config/image-card-config';

@Component({
  selector: 'lp2-group-classes-carousel',
  template: `
    <section class="p-0" #container>
      <lp2-carousel
        class="owl-w-100"
        [title]="'oeapp.studybundle.gc.sectionTitle' | translate"
        [settings]="carouselSettings"
      >
        <div *ngFor="let class of groupClasses; let i = index" class="h-100" lp2Slide>
          <lp2-group-class-tile [showDescription]="!cardImageConfig" (click)="onCardClick()" [liveClass]="class"> </lp2-group-class-tile>
        </div>
        <lp2-group-class-card *ngIf="cardImageConfig" (click)="cardImageConfig.onClick()">
          <img [ngClass]="{'card-image-pointer': cardImageConfig.isClickable }" class="card-image" [src]="cardImageConfig.imageSrc">
        </lp2-group-class-card>
      </lp2-carousel>
    </section>
  `,
  styles: [`
    .card-image-pointer {
      cursor: pointer;
    }
  `]
})
export class GroupClassCarouselComponent {
  @Input() groupClasses: LiveClassDto[];
  @Input() cardImageConfig: ImageCardConfig;

  constructor(private platformTourService: PlatformTourService, private oeAppPersonService: OeAppPersonService) {}

  carouselSettings = {
    ...DEFAULT_CAROUSEL_SETTINGS,
    margin: 0,
    stagePadding: window.innerWidth < 992 ? 45 : 0,
    responsive: {
      0: {
        items: 1,
        slideBy: 1,
      },
      525: {
        items: 1,
        slideBy: 1,
      },
      992: {
        items: 2,
        slideBy: 1,
      },
    },
  };

  onCardClick() {
    if (this.oeAppPersonService.showOnboardingModalOnGroupClass()) {
      this.platformTourService.showModal();
    }
  }
}



// WEBPACK FOOTER //
// ./ts/app/home/live-class-revamp/group-class/group-class-carousel/group-class-carousel.component.ts